import cn from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './ErrorMessage.module.scss'

interface IResponseMessageProps {
  message: string
  onClose?: () => void
}

export const ErrorMessage: FC<IResponseMessageProps> = ({ message, onClose }) => {
  return (
    <div className={cn(styles.root, styles.errorColor)}>
      {onClose ? (
        <div className={styles.closeIcon} onClick={onClose}>
          <i className="kbase kbase-close-circle" />
        </div>
      ) : null}

      <div className={styles.messageContainer}>
        <Translation text={message} />
      </div>
    </div>
  )
}
